function initializePageLayout() {
  document.body.setAttribute('data-url', location.pathname + location.search + location.hash);

  if (window.location.pathname.indexOf('/apps/proxy/ap/') !== -1) {
    document.body.classList.add('ninja-apps-hide-layout');

    // Hide sidebar and footer for Ninja app
    const aside = document.querySelector('.l-contents-side');
    if (aside) aside.style.display = 'none';

    const footers = document.querySelectorAll('.site-footer, .footer, .main-footer');
    for (const f of footers) {
      f.style.display = 'none';

      const headers = document.querySelectorAll('.is-fixed');
      for (const h of headers) {
        h.style.position = 'sticky';
        h.style.top = '0';
        h.style.zIndex = '1000';
      }
    }
  }
}

function insertEmailConfirmationSection() {
  if (window.location.pathname.indexOf('/apps/proxy/ap/') === -1) return;
  const form = document.querySelector('.pure-form');
  if (!form) return;
  const emailInput = form.querySelector('input[type="email"][name="new_email"]');
  if (!emailInput) return;
  // Prevent duplicate insertion
  if (form.querySelector('.alert-show-email')) return;

  // Get current email value
  const currentEmail = emailInput.value || '';
  // Create confirmation section
  const alertDiv = document.createElement('div');
  alertDiv.className = 'alert-show-email';
  alertDiv.innerHTML = `
    <p class="step-description">メールアドレスに間違いはありませんか？</p>
    <div class="confirm-email">
      <h3 id="ConfirmEmailValue-ninja">${currentEmail}</h3>
    </div>
  `;
  // Insert after email input
  emailInput.parentNode.insertBefore(alertDiv, emailInput.nextSibling);

  // Update confirmation in real-time
  emailInput.addEventListener('input', function (e) {
    const confirmEl = document.getElementById('ConfirmEmailValue-ninja');
    if (confirmEl) confirmEl.textContent = e.target.value.trim();
  });
}

function insertLogoAndSteps() {
  const path = window.location.pathname;
  if (path.indexOf('/apps/proxy/ap/') === -1) return;
  const form = document.querySelector('.pure-form');
  if (!form) return;
  // Prevent duplicate insertion
  if (document.querySelector('.ninja-header-actions')) return;

  // Determine step state
  const isStep1 = path === '/apps/proxy/ap/' || path === '/apps/proxy/ap';
  const isStep2 = path.indexOf('/apps/proxy/ap/input_code') !== -1;
  const isStep3 = path.indexOf('/apps/proxy/ap/message') !== -1;

  // Create header actions (logo and steps)
  const headerDiv = document.createElement('div');
  headerDiv.className = 'ninja-header-actions';
  headerDiv.innerHTML = `
    <div class="header-actions" style="margin-bottom: 18px;">
      <a class="back-link" href="/">
        <img
          src="${window.LOGO.hdLogo}" 
          alt="ショップへ戻る"
          width="166"
          height="80"
          style="height: 80px; width: 166px; display: inline-block; vertical-align: middle;"
        >
      </a>
      <p class="header-title-ninja active">メールアドレス変更</p>
      <p class="header-title-ninja hide" style="display:none;">メールアドレス変更完了</p>
    </div>
    <div class="account-step" style="max-width: 420px; width: 100%; margin-inline: auto; margin-bottom: 18px;">
      <div class="step-myaccount step-1${isStep1 ? ' active' : ''}" style="text-align: center;">
        <span>1</span>
        <p style="margin: 4px 0 0 0; font-size: 13px;">新メール<br>アドレス入力</p>
      </div>
      <div class="hr-space"></div>
      <div class="step-myaccount step-2${isStep2 ? ' active' : ''}" style=" text-align: center;">
        <span>2</span>
        <p style="margin: 4px 0 0 0; font-size: 13px;">新メール<br>アドレス認証</p>
      </div>
      <div class="hr-space" ></div>
      <div class="step-myaccount step-3${isStep3 ? ' active' : ''}" style=" text-align: center;">
        <span>3</span>
        <p style="margin: 4px 0 0 0; font-size: 13px;">変更完了</p>
      </div>
    </div>
  `;
  // Insert before the form
  form.parentNode.insertBefore(headerDiv, form);
}

function insertRequiredLabelInLegend() {
  if (window.location.pathname.indexOf('/apps/proxy/ap/') === -1) return;
  const form = document.querySelector('.pure-form');
  if (!form) return;
  const legend = form.querySelector('legend');
  if (!legend) return;
  // Prevent duplicate insertion
  if (legend.querySelector('.required')) return;

  const requiredSpan = document.createElement('span');
  requiredSpan.className = 'required';
  requiredSpan.textContent = '必須';
  requiredSpan.style.marginLeft = '8px';
  legend.appendChild(requiredSpan);
}

function insertBackToAccountButton() {
  if (window.location.pathname.indexOf('/apps/proxy/ap/') === -1) return;
  const form = document.querySelector('.pure-form');
  if (!form) return;
  // Prevent duplicate insertion
  if (form.querySelector('.da-back')) return;

  const actionsDiv = document.createElement('div');
  actionsDiv.className = 'da-actions';
  actionsDiv.style.marginTop = '18px';
  actionsDiv.innerHTML = `
    <a href="/account" class="da-btn da-back">マイページにもどる</a>
  `;
  form.appendChild(actionsDiv);
}

function insertBackToAccountButtonOnMessage() {
  if (window.location.pathname.indexOf('/apps/proxy/ap/message') === -1) return;
  const container = document.querySelector('.pure-container');
  if (!container) return;
  // Prevent duplicate insertion
  if (container.querySelector('.da-back')) return;
  // Find the text node or element with the message
  const messageText = Array.from(container.childNodes).find(
    (node) => node.nodeType === 3 && node.textContent.includes('メールアドレスを変更しました')
  );
  let insertAfter = messageText;
  if (!insertAfter) {
    // fallback: just append to container
    insertAfter = null;
  }
  const actionsDiv = document.createElement('div');
  actionsDiv.className = 'da-actions';
  actionsDiv.style.marginTop = '18px';
  actionsDiv.innerHTML = `
    <a href="/account" class="da-btn da-back">マイページにもどる</a>
  `;
  if (insertAfter && insertAfter.nextSibling) {
    container.insertBefore(actionsDiv, insertAfter.nextSibling);
  } else {
    container.appendChild(actionsDiv);
  }
}

function insertEmailValidationError() {
  if (window.location.pathname.indexOf('/apps/proxy/ap/') === -1) return;
  const form = document.querySelector('.pure-form');
  if (!form) return;
  const emailInput = form.querySelector('input[type="email"][name="new_email"]');
  if (!emailInput) return;
  let errorMsg = form.querySelector('.email-error-message');
  if (!errorMsg) {
    errorMsg = document.createElement('div');
    errorMsg.className = 'email-error-message';
    errorMsg.style.display = 'none';
    emailInput.parentNode.insertBefore(errorMsg, emailInput.nextSibling);
  }
  emailInput.addEventListener('input', function (e) {
    const value = e.target.value.trim();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    if (!value || valid) {
      errorMsg.style.display = 'none';
      errorMsg.textContent = '';
    } else {
      errorMsg.style.display = 'block';
      errorMsg.textContent = '正しいメールアドレス形式で入力してください';
    }
  });
}

function fixDuplicateErrorText() {
  if (window.location.pathname.indexOf('/apps/proxy/ap/message') === -1) return;
  const container = document.querySelector('.pure-container');
  if (!container) return;
  const h2 = container.querySelector('h2');
  if (!h2) return;
  
  // Fix duplicate error text (e.g., "エラーエラー" -> "エラー")
  const text = h2.textContent.trim();
  if (text === 'エラーエラー') {
    h2.textContent = 'エラー';
  }
}

// Call the function when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  initializePageLayout();
  insertLogoAndSteps();
  insertEmailConfirmationSection();
  insertRequiredLabelInLegend();
  insertBackToAccountButton();
  insertBackToAccountButtonOnMessage();
  insertEmailValidationError();
  fixDuplicateErrorText();
});
